import React, { useState } from 'react';
import Typography from '@lib/components/Typography/Typography';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import getFaviconUrl from '@lib/utils/getFaviconUrl';
import NewBadge from '../../NewBadge';
import styles from './ExternalLinkWidget.module.scss';

interface ExternalLinkWidgetProps {
  title: string;
  url: string;
  /** Custom icon URL from attachment (takes priority over favicon) */
  iconUrl?: string | null;
  showBadge?: boolean;
}

export default function ExternalLinkWidget({
  title,
  url,
  iconUrl,
  showBadge = false,
}: ExternalLinkWidgetProps) {
  const [iconError, setIconError] = useState(false);
  const faviconUrl = getFaviconUrl(url);

  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // Priority: custom icon > favicon > material icon
  const showCustomIcon = iconUrl && !iconError;
  const showFavicon = !showCustomIcon && faviconUrl && !iconError;

  const renderIcon = () => {
    if (showCustomIcon) {
      return (
        <div className={styles.faviconWrapper}>
          <img
            src={iconUrl}
            alt=""
            className={styles.favicon}
            onError={() => setIconError(true)}
          />
        </div>
      );
    }
    if (showFavicon) {
      return (
        <div className={styles.faviconWrapper}>
          <img
            src={faviconUrl}
            alt=""
            className={styles.favicon}
            onError={() => setIconError(true)}
          />
        </div>
      );
    }
    return (
      <div className={styles.iconCircle}>
        <MaterialIcon icon="link" size="md-16" symbolsOutlined />
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {renderIcon()}
      <Typography variant="body" className={styles.title}>
        {title}
      </Typography>
      {showBadge && <NewBadge className={styles.badge} />}
      <IconButton
        icon="arrow_outward"
        type={IconButtonTypes.PrimaryOutlined}
        onClick={handleClick}
        symbolsOutlined
      />
    </div>
  );
}
